import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {BlockService} from '../../service/BlockService';
import {UserService} from '../../service/UserService';
import {EmitterService} from '../../service/EmitterService';

@Component({
  selector: 'app-reclamation-view',
  templateUrl: './reclamation-view.component.html',
  styleUrls: ['./reclamation-view.component.css']
})
export class ReclamationViewComponent implements OnInit {
  columnsDisplay = [
    {def: 'select', show: false},
    {def: 'user', show: true},
    {def: 'status', show: true},
    {def: 'start', show: true},
    {def: 'end', show: true},
    {def: 'Motif', show: true},
    {def: 'Comment', show: true}
  ];
  public Display = {
    row: ['Réalisé validé'],
    breaks: false,
    header: true,
    paginator: false,
    buttons: {
      valider: false,
      claim: false
    },
    styles: {
      margin: {top: -10, right: 40, bottom: 20, left: 100},
      height: '100px'
    },
    dialog: false
  };
  constructor(public router: Router,
              private blockservice: BlockService,
              private user: UserService,
              private emit: EmitterService) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/view/reclamation-view/reclamation-view.component.ts